<script>
  import PartialCircleElement from "./PartialCircleElement.svelte";
  import { all_sources, find_help_text_if_exists, komma_statt_punkt, nFormatter, source_text } from "./Utils.svelte";
  import { get_years_list_from_dates } from "./UtilsBalkenProgress.svelte";
  import MarketingStatusCircleInfo from "./MarketingStatusCircleInfo.svelte";

  // export let unq_target;
  // export let psq_target;
  // export let mql_target;
  // export let opp_target;
  // export let boli_target;

  export let selected_year;
  export let selected_timeframe_text;
  export let source_cat_dict;

  export let helptexts;
  export let in_show_helptext_id;

  export let marketing_start_date;
  export let marketing_end_date;

  export let lead_target_percentage;
  export let cus_target_percentage;
  export let boli_target_percentage;
  export let lead_target_whole_year_percentage;
  export let cus_target_whole_year_percentage;
  export let boli_target_whole_year_percentage;
  export let opportunity_target_percentage;
  export let opportunity_target_whole_year_percentage;

  export let conversion_time_median_lead_to_cust;
  export let conversion_time_median_lead_to_opp;
  export let conversion_time_median_opp_to_cust;

  export let color_list;

  export let act_new_leads;
  export let act_new_opportunities;
  export let act_new_clients;
  export let act_sold_boli;

  export let target_new_leads;
  export let target_new_opportunities;
  export let target_new_clients;
  export let target_sold_boli;
  export let conversion_rate_lead_cust;
  export let conversion_rate_lead_opp;
  export let conversion_rate_opp_cust;

  export let total_target_new_leads;
  export let total_target_new_opportunities;
  export let total_target_new_clients;
  export let total_target_sold_boli;

  export let lost_new_leads;
  export let lost_new_opportunities;
  let lost_new_clients = "";
  let lost_sold_boli = "";

  export let aging_new_leads;
  export let aging_new_opportunities;
  let aging_new_clients = "";
  let aging_sold_boli = "";

  export let open_new_leads;
  export let open_new_opps;
  let open_new_clients = "";
  let open_sold_boli = "";

  export let spalte_eins_width;
  let tabellen_spaltenbreite = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  let radien = [70, 50, 50, 70, 50, 50];
  let card_width;

  "Target " + selected_year.toString();

  let act_left_column = "";
  let target_left_column = "";
  let total_target_left_columne = "";
  let lost_left_column = "";
  let aging_left_column = "";
  let open_left_column = "";

  let spalten = ["BI", "UNQ", "MQL", "OPP", "CUS", "BOLI"];

  "Target " + selected_year.toString();

  export let selected_timeframe_text_table;

  $: {
    spalte_eins_width;

    let spalte_eins_width_changed = 210;

    // if (spalte_eins_width_changed) {
    //   document.getElementById('einschub').style.width = (spalte_eins_width_changed-60).toString() + 'px';
    //   let absolute_x = document.getElementById('einschub').offsetLeft;
    //   console.log('absolute_x: ', absolute_x);
    //   console.log('einschub element: ', cumulativeOffset(document.getElementById('einschub')));
    // }

    let rest_width = card_width - spalte_eins_width_changed;

    if (rest_width && card_width) {
      const anzahl_der_spalten = spalten.length;
      let sum = spalte_eins_width_changed;

      for (let i = 0; i < anzahl_der_spalten; i = i + 1) {
        sum += tabellen_spaltenbreite[i];
      }

      for (let i = 0; i < radien.length; i = i + 1) {
        let pce_width = rest_width / 4;
        let pce_radius = (pce_width - 5) / 2;
        pce_radius = (pce_width - 5) / 2;
        radien[i] = (pce_radius - 10) * 0.6;
        // radius * 2 + 5
        // radien[i] = 40;
      }
    }
  }

  $: {
    selected_year, selected_timeframe_text_table, marketing_start_date, marketing_end_date;

    act_left_column = "Act " + selected_timeframe_text_table.toString();
    target_left_column = "Target " + selected_timeframe_text_table.toString() + " (company wide)";
    total_target_left_columne = "Target " + get_years_list_from_dates(marketing_start_date, marketing_end_date) + " (company wide)";
    lost_left_column = "Marked as lost (%)";
    aging_left_column = "Aging of all LEADS/OPP (weeks)";

    open_left_column =
      "Open LEADS/OPP (" +
      marketing_end_date.getDate().toString() +
      "." +
      (marketing_end_date.getMonth() + 1).toString() +
      "." +
      marketing_end_date.getFullYear().toString() +
      ")";
  }
</script>

<div class="card h-100">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="card-title">Marketing status report {selected_timeframe_text}</h5>
    <div class="info-circle my-auto">
      <div class="my-auto info-i">i</div>
      <div class="info-box" style="color: #000000;">
        {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_1")}
          {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_1")}
        {:else}
          <p>
            This chart provides an <strong>overview on the current status of marketing</strong> (if YTD is selected as reporting timeframe) or
            otherwise the status of marketing at the end of the reporting timeframe.&nbsp;
          </p>
          <p>You get information on:</p>
          <ul style="list-style-type: disc;">
            <li>Lead creation</li>
            <li>Opportunity creation</li>
            <li>New customers</li>
            <li>Sold Boluses</li>
          </ul>
          <p>And you can see information on:</p>
          <ul style="list-style-type: disc;">
            <li>Lost leads and opportunities</li>
            <li>
              The aging of leads and opportunities: the median time from lead/opportunity creation to a status change (lead is turned into
              an opportunity or is marked as &ldquo;Lost&rdquo;; opportunity is &ldquo;Won&rdquo; or marked as &ldquo;Lost&rdquo;) or to the
              current date (if the lead or opportunity is still open)
            </li>
            <li>The median time it takes for a lead to convert into a customer</li>
            <li>Conversion rates</li>
          </ul>
          <p><br /></p>
          <p><br /></p>
          <p><u><span style="color: rgb(124, 112, 107);">Please note&nbsp;</span></u></p>
          <ul style="list-style-type: circle;">
            <li>
              Selection of lead countries:<br /><span style="color: rgb(124, 112, 107);"
                >All information in the Marketing status report relates to the countries selected under &ldquo;Select lead countries&rdquo;.
                This means that the leads, opportunities, customers, and sold boluses in these countries form the basis of the charts and
                information in this report. Exception: the targets (timeframe target and annual target) in the data table always show the
                targets for all countries.&nbsp;</span
              ><br /><br />
            </li>
            <li>
              Selection of source categories:<br /><span style="color: rgb(124, 112, 107);"
                >The source category selection only affects &ldquo;New Leads&rdquo; and &ldquo;New opportunities&rdquo;. New customers and
                sold boluses are not affected by the source category selection.</span
              >
            </li>
            <li>
              Handling of leads based on data imports:<br /><span style="color: rgb(124, 112, 107);"
                >Leads from the sales source category &quot;data import&quot; are only counted as &rdquo;new lead&quot; if an opportunity is
                created based on the lead. In this case, the lead creation date is the same as the opportunity creation date.</span
              >
            </li>
          </ul>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_1</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div>
  </div>

  <div class="card-body" style="margin-bottom:0px; padding-bottom: 0px;">
    <div class="col" bind:clientWidth={card_width}>
      <!-- <div class="row d-flex" style="padding-bottom:30px; margin-right: 0px; padding-right: 0px;">
        <div class="col d-flex no-padding-and-margin" id="einschub" style="width:210px !important; height:210px;" />

     
      </div> -->

      <div class="row" height="{600}px;">
        <table class="table" style="color: #262626;">
          <!-- <thead>
            <tr>
              <th style="text-align: center; width:210px;" bind:clientWidth={spalte_eins_width} scope="col">#</th>
              {#each spalten as r, index}
                <th style="text-align: center;" bind:clientWidth={tabellen_spaltenbreite[index]} scope="col">{r}</th>
              {/each}
            </tr>
          </thead> -->

          <col style="width:25%" />
          <col style="width:25%" />
          <col style="width:25%" />
          <col style="width:25%" />

          <tbody>
            <tr style="height: {radien[0] * 3 + 20}px; border:none;">
              <td style="border:none;" />

              <td class="hoverclass" style="border:none;  "
                ><div class="">
                  <PartialCircleElement
                    id="pce3"
                    winkel_innen={lead_target_percentage}
                    winkel_outer={lead_target_whole_year_percentage}
                    number={3}
                    text_box={"New LEADS"}
                    text_box_color={color_list[0]}
                    bind:radius={radien[2]}
                    source_text={source_text(source_cat_dict)}
                    source_color={all_sources(source_cat_dict) ? "#455F51" : color_list[0]}
                  />

                  <div class="info-box" style="width: 34%;margin-top: 170px;">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_2")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_2")}
                    {:else}
                      <MarketingStatusCircleInfo />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_2</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >

              <td style="border:none; " class="hoverclass"
                ><div class="">
                  <PartialCircleElement
                    id="pce4"
                    winkel_innen={opportunity_target_percentage}
                    winkel_outer={opportunity_target_whole_year_percentage}
                    number={4}
                    text_box={"New OPP"}
                    text_box_color={color_list[1]}
                    bind:radius={radien[2]}
                    source_text={source_text(source_cat_dict)}
                    source_color={all_sources(source_cat_dict) ? "#455F51" : color_list[1]}
                  />
                  <div class="info-box" style="width: 34%;margin-top: 170px;">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_3")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_3")}
                    {:else}
                      <MarketingStatusCircleInfo />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_3</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >

              <td style="border:none; " class="hoverclass"
                ><div class="">
                  <PartialCircleElement
                    id="pce5"
                    winkel_innen={cus_target_percentage}
                    winkel_outer={cus_target_whole_year_percentage}
                    number={5}
                    text_box={"New CUST"}
                    text_box_color={color_list[2]}
                    bind:radius={radien[4]}
                    source_text={"All sources"}
                    source_color={"#455F51"}
                  />
                  <div class="info-box" style="width: 34%;margin-top: 170px;">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_4")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_4")}
                    {:else}
                      <MarketingStatusCircleInfo />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_4</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >
              <td style="border:none; " class="hoverclass"
                ><div class="">
                  <PartialCircleElement
                    id="pce6"
                    winkel_innen={boli_target_percentage}
                    winkel_outer={boli_target_whole_year_percentage}
                    number={6}
                    text_box={"Sold BOLUSES"}
                    text_box_color={color_list[3]}
                    bind:radius={radien[5]}
                    source_text={"All sources"}
                    source_color={"#455F51"}
                  />
                  <div class="info-box" style="width: 34%;margin-top: 170px;">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_5")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_5")}
                    {:else}
                      <MarketingStatusCircleInfo />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_5</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >
            </tr>

            <tr>
              <td class="" style="text-align: left;">
                {act_left_column}
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_6")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_6")}
                    {:else}
                      <p>
                        <strong>Act</strong> &hellip; Actual total number of leads (or opportunities, customers) created or boluses sold during
                        the reporting timeframe.
                      </p>

                      <p>
                        <span style="color: rgb(124, 112, 107);"
                          >Example: 371 means (depending on the column) that 371 new leads (or opportunties or customers) have been created
                          or 371 boluses have been sold within the reporting timeframe.</span
                        >
                      </p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_6</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(act_new_leads)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(act_new_opportunities)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(act_new_clients)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(act_sold_boli)}</div>
              </td>
            </tr>

            <tr style="color: #4eb3cf;">
              <td class="" style="text-align: left; color: #4eb3cf;">
                {target_left_column}
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_7")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_7")}
                    {:else}
                      <p>
                        <strong><span style="color: #4eb3cf;">Target month/year </span></strong>&nbsp;&hellip; Target for the number of new
                        leads (or new opportunities, new customers, sold boluses) for all countries in the reporting timeframe.
                      </p>
                      <p>
                        <span style="color: rgb(124, 112, 107);"
                          >Example: 917 means that the target for the total number for new leads (new opportunities, new customers, sold
                          boluses) is 917 in the reporting timeframe.</span
                        >
                      </p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_7</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(target_new_leads)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(target_new_opportunities)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(target_new_clients, 0)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(target_sold_boli)}</div>
              </td>
            </tr>

            <tr style="color: #4eb3cf;">
              <td class="" style="text-align: left; color: #4eb3cf;">
                {total_target_left_columne}
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_8")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_8")}
                    {:else}
                      <p>
                        <strong><span style="color: #4eb3cf;">Target year</span></strong> &nbsp;&hellip; Target for the number of new leads (or
                        new opportunities, new customers, sold boluses) for the whole year(s) of the reporting timeframe (for all countries).
                      </p>

                      <p>
                        <span style="color: rgb(124, 112, 107);"
                          >Example: 11k means that the target for the total number for new leads (new opportunities, new customers, sold
                          boluses) is 11.000 for the whole year of the selected reporting timeframe. If the reporting timeframe affects two
                          years (e.b. 11/2022 &ndash; 03/2023), this number is the total of the target of both years.</span
                        >
                      </p>

                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_8</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(total_target_new_leads)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(total_target_new_opportunities)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(total_target_new_clients)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; color: #4eb3cf;">
                <div style="padding-right: 20px;">{nFormatter(total_target_sold_boli)}</div>
              </td>
            </tr>

            <tr style="color: #7F7F7F;">
              <td class="" style="text-align: left; ">
                {open_left_column}
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_9")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_9")}
                    {:else}
                      <p>
                        <span style="color: rgb(124, 112, 107);"><strong>Open LEADS/OPP (dd.mm.yyyy)</strong></span>&hellip; Number of open
                        leads (or opportunities) at the last day of the reporting timeframe.
                      </p>
                      <p>
                        <span style="color: rgb(124, 112, 107);"
                          >Example: 29,7k means that there are 29,7k open leads (or opportunities) at the last day of the selected reporting
                          timeframe.</span
                        >
                      </p>
                      <p><br /></p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_9</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(open_new_leads)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(open_new_opps)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(open_new_clients)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(open_sold_boli)}</div>
              </td>
            </tr>

            <tr>
              <td class="" style="text-align: left;">
                {aging_left_column}
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_10")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_10")}
                    {:else}
                      <p>
                        <strong>Aging of all LEADS/OPP (weeks)</strong>&hellip; Median age of all leads (or opportunities) open during the
                        reporting timeframe. <br /> <br />
                        <u>The aging of leads</u> is calculated as time between lead creation and the last day of the reporting timeframe
                        (if the lead is still open) or the date the lead was converted to an opportunity or was marked as “Lost”. <br />
                        <br />
                        <u>The aging of opportunities</u> is calculated as time between the opportunity creation and the last day of the reporting
                        timeframe (if the opportunity is still open) or the date the opportunity was won or marked as “Lost”.
                      </p>

                      <p>
                        <span style="color: rgb(124, 112, 107);"
                          >Example: “0,1w” means that the median (not average) duration between the creation of a lead and a status change
                          of the lead (to “Marked as Lost“ or to the creation of an opportuntity) or to the end of the reporting timeframe
                          (if the lead is still open) is 0,1 weeks.</span
                        >
                      </p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_10</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(aging_new_leads)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(aging_new_opportunities)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(aging_new_clients)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(aging_sold_boli)}</div>
              </td>
            </tr>

            <tr>
              <td class="" style="text-align: left;">
                Conversion rate/time LEADS-> CUST
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_12")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_12")}
                    {:else}
                      <p>
                        <strong>Conversion rate / time LEADS -&gt; CUST</strong> &hellip;Conversion rate and conversion time from leads to
                        customers (in % / weeks).
                        <br /> <br />
                        <u>Calculation of conversion rate: </u>Total number of customers created within the reporting timeframe / Total
                        number of leads open in reporting timeframe.<br /> <br />
                        <u>Calculation of conversion time: </u>For all customers won during the reporting timeframe: Median time from lead
                        creation date to the date, the opportunity was marked as “won” (in weeks).
                      </p>

                      <p>
                        <span style="color: rgb(124, 112, 107);"
                          >Example for conversion time: “10,5w“ means that for customers, won during the reporting timeframe, the median
                          time from lead creation to the opportunity being marked "won" was 10,5 weeks.</span
                        >
                      </p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_12</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >
              <td nowrap ALIGN="CENTER" style="text-align: center; background-color: #F2F2F2;">
                <div style="padding-right: 20px;" />
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; background-color: #F2F2F2;">
                <div style="padding-right: 20px;">
                  {komma_statt_punkt(conversion_rate_lead_cust)}% / {komma_statt_punkt(
                    (conversion_time_median_lead_to_cust / 7).toFixed(1).toString() + "w",
                  )}
                </div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center; background-color: #F2F2F2;">
                <div style="padding-right: 20px;" />
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;" />
              </td>
            </tr>

            <tr>
              <td class="" style="text-align: left;">
                Conversion rate/time LEADS -> OPP
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_13")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_13")}
                    {:else}
                      <p>
                        <strong>Conversion rate / time LEADS -&gt; OPP</strong> &hellip; … Conversion rate from leads to opportunities (in %
                        / weeks). <br /> <br />

                        <u>Calculation of conversion rate: </u>Total number of opportunities created within the reporting timeframe / Total
                        number of leads open in reporting timeframe.<br /> <br />
                        <u>Calculation of conversion time: </u>For all opportunities created during the reporting timeframe: Median time
                        from lead creation date to creation date of the opportunity that was created based on that lead (in weeks).
                      </p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_13</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >

              <td colspan="2" nowrap ALIGN="CENTER" style="text-align: center; background-color: #F2F2F2;">
                <div style="padding-right: 20px;">
                  {komma_statt_punkt(conversion_rate_lead_opp)}% / {komma_statt_punkt(
                    (conversion_time_median_lead_to_opp / 7).toFixed(1).toString() + "w",
                  )}
                </div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;" />
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;" />
              </td>
            </tr>

            <tr>
              <td class="" style="text-align: left;">
                Conversion rate/time OPP -> CUST <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_14")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_14")}
                    {:else}
                      <p>
                        <strong>Conversion rate / time OPP -&gt; CUS</strong> &hellip; … Conversion rate from opportunities to customers (in
                        %).
                        <br /> <br />
                        <u>Calculation of conversion rate: </u>Total number of customers created within the reporting timeframe / Total
                        number of opportunities open in reporting timeframe.<br /> <br />
                        <u>Calculation of conversion time: </u>For all customers won during the reporting timeframe: Median time from
                        opportunity creation date to the date, the opportunity was marked as “won” (in weeks).
                      </p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_14</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div></td
              >
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;" />
              </td>
              <td colspan="2" nowrap ALIGN="CENTER" style="text-align: center; background-color: #F2F2F2;">
                <div style="padding-right: 20px;">
                  {komma_statt_punkt(conversion_rate_opp_cust)}% / {komma_statt_punkt(
                    (conversion_time_median_opp_to_cust / 7).toFixed(1).toString() + "w",
                  )}
                </div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;" />
              </td>
            </tr>

            <tr>
              <td class="" style="text-align: left;">
                {lost_left_column}
                <div class="hoverclass" style="display: inline-block; width: 20px;">
                  <b>ⓘ</b>
                  <div class="info-box-auf-hoehe">
                    {#if find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_15")}
                      {@html find_help_text_if_exists(helptexts, "marketing_mirror_zweite_tabelle_15")}
                    {:else}
                      <p>
                        <strong>Mark as lost (%)</strong>&hellip; Number of leads (or opportunities), that have been marked as
                        &ldquo;Lost&rdquo; during the reporting timeframe in % of the number of open leads during the reporting timeframe.
                      </p>
                      <p>
                        <span style="color: rgb(124, 112, 107);"
                          >Example: 2,4% means that 2,4% of the leads open during the reporting timeframe have been marked as
                          &bdquo;Lost&ldquo;.</span
                        >
                      </p>
                      <p><br /></p>
                      <br /><br />
                    {/if}
                    {#if in_show_helptext_id}
                      <div style="font-size: 7px">id: marketing_mirror_zweite_tabelle_15</div>
                      <div style="font-size: 7px">
                        [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                      </div>
                    {/if}
                  </div>
                </div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(lost_new_leads)}%</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(lost_new_opportunities)}%</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(lost_new_clients)}</div>
              </td>
              <td nowrap ALIGN="CENTER" style="text-align: center;">
                <div style="padding-right: 20px;">{nFormatter(lost_sold_boli)}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row" height="{200}px;">
        <div class="row" style="padding:20px">
          <div class="col" style="max-width:25%;">
            <div class="small-text">
              <div class="small-rect-1" style="float:left;">◎</div>
              <div style="overflow:hidden;">&nbsp; Target in timeframe (=100%)</div>
            </div>
          </div>

          <div class="col" style="max-width:25%;">
            <div class="small-text">
              <img style="float:left;" class="funnel" src="/static/img/icons/legend_green_donut.png" alt="background image" />
              <div style="overflow:hidden;">&nbsp; Act within timeframe/Target in timeframe</div>
            </div>
          </div>

          <div class="col" style="max-width:25%;">
            <div class="small-text">
              <img style="float:left;" class="funnel" src="/static/img/icons/legend_black_donut.png" alt="background image" />
              <div style="overflow:hidden;">&nbsp; Share of Act within timeframe on total target in year of timeframe</div>
            </div>
          </div>

          <div class="col" style="max-width:25%;">
            <div class="small-text">
              <div class="small-rect-1" style="float:left;">%</div>
              <div style="overflow:hidden;">&nbsp; Act within timeframe / Target in timeframe</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  img {
    width: 10px;
    height: 10px;
  }

  .small-text {
    font-size: 9px;
  }

  .small-rect-1 {
    width: 10px;
    height: 10px;
    padding: 0px;
  }

  .small-rect-2 {
    width: 10px;
    height: 10px;
    padding: 0px;
  }

  .conversionrate-tabellen-markierung {
    background-color: #d7e2dc;
    height: 40px;
    width: 90%;
    padding: 5px;
    vertical-align: middle;
  }

  .balken-title {
    background-color: #d7e2dc;
    padding-left: 3px;
    padding-top: 3px;
    padding-bottom: 0px;
  }

  .vertical-center {
    display: flex;
    align-items: center;
  }

  .horizontal-center {
    display: flex;
    justify-content: center;
  }

  .no-padding-and-margin {
    padding: 0px;
    margin: 0px;
  }

  td {
    text-align: right;
    min-width: 10px;
    padding-top: 7px;
    padding-bottom: 7px;
  }
  td > div {
    width: 50%;
    text-align: right;
  }

  .width-100 {
    width: 200% !important;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 70%;
    margin-left: 20px;
    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: inherit;
    left: calc(var(--x) * 2);
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
    line-height: 130%;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600px;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 50px;
    /*    top: 0;*/
    right: 50px;
    /*    left: 0;*/
    /*    transform: translate(calc(var(--x)), calc(var(--y)));*/
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
    line-height: 130%;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
